import React, { useState, useEffect } from 'react';
import { Comparitor } from '../types';

interface CriteriaContinousValueInputProps {
  current_value: (number | undefined)[] | number | string[] | undefined;
  current_comparitor: Comparitor | null;
  setInputValues: React.Dispatch<React.SetStateAction<number | (number | undefined)[] | string[] | undefined>>;
}

const CriteriaContinousValueInput: React.FC<CriteriaContinousValueInputProps> = ({
  current_comparitor,
  current_value,
  setInputValues,
}) => {
  // Use simple string input states without validation
  const [input1, setInput1] = useState('');
  const [input2, setInput2] = useState('');

  // Update inputs when props change
  useEffect(() => {
    if (current_comparitor === 'range' && Array.isArray(current_value)) {
      setInput1(current_value[0] !== undefined ? String(current_value[0]) : '');
      setInput2(current_value[1] !== undefined ? String(current_value[1]) : '');
    } else if (typeof current_value === 'number') {
      setInput1(String(current_value));
      setInput2('');
    } else {
      setInput1('');
      setInput2('');
    }
  }, [current_value, current_comparitor]);

  // Handle changes for the first input
  const handleInput1Change = (e: React.ChangeEvent<HTMLInputElement>) => {
    const newValue = e.target.value;
    setInput1(newValue);
    
    // Update parent component
    if (current_comparitor === 'range') {
      const val1 = newValue === '' ? undefined : Number(newValue);
      const val2 = input2 === '' ? undefined : Number(input2);
      setInputValues([val1, val2]);
    } else {
      setInputValues(newValue === '' ? undefined : Number(newValue));
    }
  };

  // Handle changes for the second input
  const handleInput2Change = (e: React.ChangeEvent<HTMLInputElement>) => {
    const newValue = e.target.value;
    setInput2(newValue);
    
    // In range mode, update parent with both values
    if (current_comparitor === 'range') {
      const val1 = input1 === '' ? undefined : Number(input1);
      const val2 = newValue === '' ? undefined : Number(newValue);
      setInputValues([val1, val2]);
    }
  };

  // Simple CSS based on the design in the images
  const inputStyle = {
    width: '100%',
    padding: '8px 12px',
    fontSize: '14px',
    height: '38px',
    border: '1px solid #e2e8f0',
    borderRadius: '4px',
    boxSizing: 'border-box' as 'border-box'
  };

  return (
    <div style={{ width: '100%' }}>
      {current_comparitor === 'range' ? (
        <div style={{ display: 'flex', gap: '8px', width: '100%' }}>
          <div style={{ flex: 1 }}>
            <input
              type="number"
              value={input1}
              onChange={handleInput1Change}
              placeholder="Start value"
              style={inputStyle}
            />
          </div>
          <div style={{ flex: 1 }}>
            <input
              type="number"
              value={input2}
              onChange={handleInput2Change}
              placeholder="End value"
              style={inputStyle}
            />
          </div>
        </div>
      ) : (
        <div style={{ width: '100%' }}>
          <input
            type="number"
            value={input1}
            onChange={handleInput1Change}
            placeholder={current_comparitor ? `${current_comparitor}` : "value"}
            style={inputStyle}
          />
        </div>
      )}
    </div>
  );
};

export default CriteriaContinousValueInput;